import {BehaviorSubject, map, Observable, shareReplay, startWith} from 'rxjs';
import {currencies$, marginCurrencies$, marginPairs$} from './config';
import {marginAccounts$} from './margin';

export const orderPopperState$ = new BehaviorSubject(null);

export const matchCurrencyAction$: Observable<(key: CurrencyEntity['currency']) => CurrencyEntity> = currencies$.pipe(
  map((currencies) => convertArrayToMap(currencies, 'currency')),
  map((dataMap) => (key) => dataMap[key]),
  startWith(() => {}),
  shareReplay(1)
);

export const matchMarginCurrencyAction$: Observable<(key: MarginCurrencyEntity['currency']) => MarginCurrencyEntity> = marginCurrencies$.pipe(
  map((currencies) => convertArrayToMap(currencies, 'currency')),
  map((dataMap) => (key) => dataMap[key]),
  startWith(() => {}),
  shareReplay(1)
);

export const matchMarginAccountAction$: Observable<(key: MarginAccount['currency']) => MarginAccount> = marginAccounts$.pipe(
  map((marginAccounts) => convertArrayToMap(marginAccounts, 'currency')),
  map((dataMap) => (key) => dataMap[key]),
  startWith(() => {}),
  shareReplay(1)
);

export const matchMarginPairAction$: Observable<(key: MarginPair['symbol']) => MarginPair> = marginPairs$.pipe(
  map((marginPairs) => convertArrayToMap(marginPairs, 'symbol')),
  map((dataMap) => (key) => dataMap[key]),
  startWith(() => {}),
  shareReplay(1)
);

function convertArrayToMap(arrayData, key) {
  return arrayData.reduce((preValue, item) => {
    preValue[item[key]] = item;
    return preValue;
  }, {});
}
